import {useCallback, useSyncExternalStore} from "react";

export type NavLayout = "top" | "side";

const KEY = "hub-go.nav-layout";
const CHANGED = "hub-go:nav-layout";

const read = (): NavLayout => {
  try {
    return localStorage.getItem(KEY) === "side" ? "side" : "top";
  } catch {
    return "top";
  }
};

const subscribe = (onChange: () => void) => {
  window.addEventListener(CHANGED, onChange);
  window.addEventListener("storage", onChange);
  return () => {
    window.removeEventListener(CHANGED, onChange);
    window.removeEventListener("storage", onChange);
  };
};

/** Where HubGo's navigation sits: across the top (the default) or down the side. Remembered per browser. */
export const useNavLayout = (): [NavLayout, (layout: NavLayout) => void] => {
  const layout = useSyncExternalStore(subscribe, read, () => "top" as const);
  const setLayout = useCallback((next: NavLayout) => {
    try {
      localStorage.setItem(KEY, next);
    } catch {
      // Private browsing: the choice lasts until the page reloads.
    }
    window.dispatchEvent(new Event(CHANGED));
  }, []);
  return [layout, setLayout];
};
